import { render, staticRenderFns } from "./CompanyHistoryContainer.vue?vue&type=template&id=a48e2630&"
import script from "./CompanyHistoryContainer.vue?vue&type=script&lang=js&"
export * from "./CompanyHistoryContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
